// ProgressSemiCircle.js
import React, { useEffect, useRef, useState } from 'react';
import ProgressBar from 'progressbar.js';
import styled from 'styled-components';  

const ProgresstContainer = styled.div`  
  background-color: #ffffff; /* 背景色を白に統一 */
  border-radius: 15px; /* 角を丸く */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 影を追加して浮かび上がるように */
  padding: 20px; /* パディングを追加 */
  flex: 1;
  position: relative; /* 相対位置を指定 */
  // display: flex;
  justify-content: center; /* コンテンツを中央揃え */
  align-items: center; /* コンテンツを垂直中央に揃え */
  min-height: 30px; /* 最低限の高さを指定してみる */
  
    @media (min-width: 768px) {  
    min-height: 50px; /* 最低限の高さを指定してみる */
  }  
`;

const ProgressSemiCircle = ({ progress }) => {
  const progressBarContainer = useRef(null);
  const progressBarRef = useRef(null);  // ProgressBarを保持するためのref
  const [strokeWidth, setStrokeWidth] = useState(2);  // 初期値はデフォルトの太さ

  useEffect(() => {
    // 画面サイズに応じて太さを変更
    const updateStrokeWidth = () => {
      if (window.innerWidth < 768) {
        setStrokeWidth(4);  // スマホの場合は太さを3に設定
      } else {
        setStrokeWidth(2);  // PCやタブレットの場合は太さを10に設定
      }
    };

    updateStrokeWidth(); // 初期ロード時の設定
    window.addEventListener('resize', updateStrokeWidth); // 画面サイズ変更に対応

    // クリーンアップ
    return () => {
      window.removeEventListener('resize', updateStrokeWidth);
    };
  }, []);  // 画面幅を監視して更新

  useEffect(() => {
    const line = new ProgressBar.Line(progressBarContainer.current, {
      strokeWidth: strokeWidth,
      color: '#007c3e',
      trailColor: '#eee',
      trailWidth: 1,
      easing: 'easeInOut',
      duration: 1400,
      svgStyle: { strokeLinecap: 'round' }, // ここで端に丸みを追加
      text: {
        value: '',
        style: {
          color: '#007c3e',  // テキストの色
          fontSize: '4rem',  // フォントサイズを大きくする
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translate(-50%, -50%)',  // 中央に配置するための変換
          textAlign: 'center',  // テキストを中央揃えにする
          whiteSpace: 'nowrap',  // 改行を防ぐ
        }
      },
      from: { color: '#FFEA82' },  // 開始時の色
      to: { color: '#007c3e' },  // 終了時の色
      step: (state, bar) => {
        // 2行のテキストをHTMLで設定
        bar.setText(`
          <span style="font-size: 1rem">ロボット稼働率  ${Math.round(bar.value() * 100)}%</span>
        `);
        bar.path.setAttribute('stroke', state.color);
      }
    });

    line.animate(progress); // 進捗に応じてアニメーション
    progressBarRef.current = line;  // ProgressBarインスタンスをrefに保存

    // クリーンアップ関数を使ってコンポーネントがアンマウントされたときにバーを破棄
    return () => {
      if (progressBarRef.current) {
        progressBarRef.current.destroy();
      }
    };
  }, [progress, strokeWidth]);

  return (
    <ProgresstContainer>
      <div ref={progressBarContainer} style={{ position: 'relative', width: '100%' }}></div>
    </ProgresstContainer>
  );
};

export default ProgressSemiCircle;
